export default function(settings, raw_query, controller){

  if(typeof controller === 'object' && `_contentElements` in controller)
  {
    if(!(`filter` in controller._contentElements) || !(controller._contentElements.filter instanceof HTMLElement))
    {
      console.debug('Settings up filter...',settings);
      controller._contentElements.filter=document.createElement("form");
      controller._contentElements.filter.target="";
      controller._contentElements.filter.setAttribute('style','padding-bottom:10px;padding-top:10px;border-bottom:2px solid grey;margin-bottom:10px;');
    }

   let has_actions = false;

    if(`keyword` in settings)
    {
      console.debug('Adding keyword...',settings);
      let keyword_component = document.createElement("input");
      keyword_component.type="text";
      keyword_component.name=settings.keyword;
      keyword_component.value=(settings.keyword in raw_query?raw_query[settings.keyword]:'');
      keyword_component.placeholder="Please enter a keyword";
      controller._contentElements.filter.append(keyword_component);
      has_actions=true;
    }

    console.error(raw_query);

    if(has_actions)
    {
      console.debug('Adding submit...',settings);
      let searchButton_component = document.createElement("input");
      searchButton_component.value="Search";
      searchButton_component.type = 'submit';
      if(controller.dsbClient.user.is_offline())
      {
        searchButton_component.disabled = true;
      }
      else
      {
        controller._contentElements.filter.addEventListener('submit', async event => {
            // submit event detected
            event.preventDefault()

            const formData = new FormData(event.target);
            const entries = formData.entries();
            let submission = Object.fromEntries(entries);
            let del=[];

            let query = controller.dsbClient.content.processQuery(controller.query,submission,'object');
            for(let akey in query)
            {
              if(query[akey].length == 0)
              {
                delete query[akey]
              }
            }
            query['_[skip]']=0;
            controller.setAttribute('query',controller.dsbClient.content.processQuery(query));

        });
      }
      controller._contentElements.filter.append(searchButton_component);
    }

    return controller._contentElements.filter;
  }
  else
  {
    throw "controller._contentElements is not an object!";
  }

}
